const de = {

    message: {

        title1: 'Fernsteuerung von Smart Home, Technologie, Sicherheit und Seelenfrieden',

        content1: ' Mit AigoSmart können Sie Smart-Home-Geräte aus der Ferne verwalten und steuern. Die Geräte können sich auch gegenseitig wahrnehmen und verknüpfen. Durch Auslösen mit einem Klick können verschiedene Haushaltsgeräte in Ihren voreingestellten Zustand versetzt werden, wodurch ein sicheres und sorgenfreies Smart-Home für Sie entsteht Leben.',

        title2: "AigoSmart ist eine neue Untermarke von Aigostar",

        content2: "Die Produkte werden derzeit nach Spanien, Portugal, Frankreich, Italien, den Niederlanden, Deutschland, Finnland, Dänemark, Polen, Russland, Griechenland, Österreich, der Schweiz, der Tschechischen Republik, Ungarn, der Slowakei und anderen europäischen Ländern und Regionen verkauft.",

        content3: " Die verschiedenen Küchen-, Wäsche- und Bügelkleingeräte von AIGOSTAR belegen weiterhin",

        content4: " Top Ten Verkäufe",

        title3: "Brand Honor",

        content5: "Schnell. Öffnen. Innovieren. Durchhalten",

        loading: 'Laden',

        submit: 'Absenden',

        contactUs: "Kontakt",

        privacy: "Datenschutzvereinbarung",

        policy: "Servicerichtlinie",

        download: "Download",



    },

}



export default de;